import axios from "axios";
import { retrieveStoredData } from "../store/authContext";

const api = axios.create({
  headers: {
    accept: "application/json",
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(async (config) => {
  const url = ((window.APP_CONFIG && window.APP_CONFIG.apiBaseUrl) || "https://d.mconf.rnp.br/");
  if (url) {
    config.baseURL = url;
  }

  const data = retrieveStoredData();
  if (data?.token) {
    config.headers = { Authorization: data?.token };
  }

  return config;
});

export default api;
